import { BaseConfig } from "../config.interface";
import { Size, Validate } from "../util";

interface IInputCurrencyConfig {
    label?: string;
    validate: Validate;
    size: Size;
    clear?: boolean;
}

export class InputCurrencyConfig extends BaseConfig<IInputCurrencyConfig> implements IInputCurrencyConfig {
    /**
     * Label of the element.
     */
    label?: string;
    /**
     * Show validation status already in `pristine` state or after it has been marked as `dirty`.
     */
    validate: Validate;
    size: Size;
    /**
     * Show a clear button.
     */
    clear?: boolean;

    /**
     * @theme Base
     */
    static baseTheme = {
        /**
         * Default configuration.
         * Number value with step of 1.
         */
        Default: new InputCurrencyConfig({
            validate: "dirty",
            size:     "small",
        }),
        Medium: new InputCurrencyConfig({
            validate: "dirty",
            size:     "medium",
        }),
        Large: new InputCurrencyConfig({
            validate: "dirty",
            size:     "large",
        }),
    };
}